import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["data-collapsed"]
const _hoisted_2 = { class: "grid gap-1 group-[[data-collapsed=true]]:justify-center group-[[data-collapsed=true]]:px-2" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "font-semibold px-5 py-2 bg-gray-400" }
const _hoisted_5 = {
  key: 1,
  class: "px-2"
}
const _hoisted_6 = ["href", "onClick"]
const _hoisted_7 = { class: "sr-only" }
const _hoisted_8 = ["onClick", "href"]

import { Icon } from '@iconify/vue';
import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/utils/utils";
import { Tooltip, TooltipTrigger, TooltipContent } from "@/components/ui/tooltip";
import { ref } from 'vue';
import { useRouter } from 'vue-router';

export interface LinkProp {
  title: string;
  icon: string;
  to: any;
  variant: 'default' | 'ghost';
  root: string |'none';
}

interface NavProps {
  isCollapsed: boolean;
  links: LinkProp[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Nav',
  props: {
    isCollapsed: { type: Boolean },
    links: {}
  },
  setup(__props: any) {

const props = __props;
const selectedLink = ref<string | null>(null);
const router = useRouter();

const handleLinkClick = async (title: string, to: any) => {
  router.push(to);
  selectedLink.value = title;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    "data-collapsed": props.isCollapsed,
    class: "group flex flex-col gap-4 data-[collapsed=true]:py-2"
  }, [
    _createElementVNode("nav", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.links, (link, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          (link.root==='yes')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("p", _hoisted_4, _toDisplayString(link.title), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (props.isCollapsed)
                  ? (_openBlock(), _createBlock(_unref(Tooltip), {
                      key: `1-${index}`,
                      "delay-duration": 0
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(TooltipTrigger), { "as-child": "" }, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              href: link.to,
                              class: _normalizeClass(_unref(cn)(
                    _unref(buttonVariants)({ variant: link.variant, size: 'icon' }),
                    'h-9 w-9',
                    link.variant === 'default' && 'dark:bg-muted dark:text-muted-foreground dark:hover:bg-muted dark:hover:text-white',
                    { 'text-red-500': selectedLink.value === link.title }
                  )),
                              onClick: _withModifiers(($event: any) => (handleLinkClick(link.title, link.to)), ["prevent"])
                            }, [
                              _createVNode(_unref(Icon), {
                                icon: link.icon,
                                class: "size-4"
                              }, null, 8, ["icon"]),
                              _createElementVNode("span", _hoisted_7, _toDisplayString(link.title), 1)
                            ], 10, _hoisted_6)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_unref(TooltipContent), {
                          side: "right",
                          class: "flex items-center gap-4"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(link.title), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  : (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      onClick: _withModifiers(($event: any) => (handleLinkClick(link.title, link.to)), ["prevent"]),
                      href: link.to,
                      class: _normalizeClass(_unref(cn)(
            _unref(buttonVariants)({ variant: link.variant, size: 'sm' }),
            link.variant === 'default' && 'dark:bg-muted dark:text-white dark:hover:bg-muted dark:hover:text-white',
            'justify-start w-full',
            { 'text-red-500': selectedLink.value === link.title }
          ))
                    }, [
                      _createVNode(_unref(Icon), {
                        icon: link.icon,
                        class: "mr-2 size-4"
                      }, null, 8, ["icon"]),
                      _createTextVNode(" " + _toDisplayString(link.title), 1)
                    ], 10, _hoisted_8))
              ]))
        ], 64))
      }), 128)),
      _createElementVNode("a", {
        href: "./media/pdf/docs.pdf",
        target: "_blank",
        class: _normalizeClass(_unref(cn)(
            _unref(buttonVariants)({ variant: 'ghost', size: 'sm' }),
            'dark:bg-muted dark:text-white dark:hover:bg-muted dark:hover:text-white',
            'justify-start w-full',
          ))
      }, [
        _createVNode(_unref(Icon), {
          icon: "lucide:circle-help",
          class: "mr-2 size-4"
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('menu.help')), 1)
      ], 2)
    ])
  ], 8, _hoisted_1))
}
}

})